<template>
  <div>
    <Loader :is-visible="loading" />

    <el-table :data="substitutionsData">
      <!-- Details table to expand -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.details">
            <el-table-column label="Client" prop="client" width="260">
              <template slot-scope="detailsScope">
                <span
                  class="user-link"
                  @click="goToClient(detailsScope.row.client.id)"
                >
                  {{ detailsScope.row.client.fullName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Commande"
              prop="id"
              align="center"
              width="300"
            >
              <template slot-scope="detailsScope">
                <span
                  class="user-link"
                  @click="goToOrder(detailsScope.row.id)"
                  >{{ detailsScope.row.packName }}</span
                >
                <template v-if="detailsScope.row.label">
                  <br />
                  <small>{{ detailsScope.row.label }}</small>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              label="Commercial"
              prop="commercials"
              align="center"
              width="300"
            >
              <template slot-scope="detailsScope">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                  style="gap: 5px"
                >
                  <div
                    v-for="commercialRel in detailsScope.row.commercials"
                    :key="commercialRel.id"
                    class="d-flex align-items-center"
                  >
                    <CommercialRel :relation="commercialRel" />

                    <el-popover
                      placement="top"
                      width="350"
                      trigger="hover"
                      content="Envoyer un mail de notification de la demande de remplacement au commercial"
                    >
                      <button
                        v-if="status !== 'rejected'"
                        slot="reference"
                        class="btn btn-sm btn-secondary ml-1"
                        :disabled="
                          sendingNotification.includes(detailsScope.row.id)
                        "
                        @click="
                          notifyCommercial(
                            commercialRel.userEmail,
                            scope.row.id,
                            detailsScope.row.id,
                          )
                        "
                      >
                        <i class="fa fa-envelope"></i>
                      </button>
                    </el-popover>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Notebook"
              prop="notebook"
              align="center"
              width="300"
            >
              <template slot-scope="detailsScope">
                <button
                  type="button"
                  class="btn btn-sm btn-secondary"
                  @click="showNotebook(detailsScope.row)"
                >
                  <i class="fa fa-commenting"></i>
                  ({{
                    detailsScope.row.notebook
                      ? detailsScope.row.notebook.length
                      : 0
                  }}) Consulter
                </button>
              </template>
            </el-table-column>
            <el-table-column
              label="Coach Manager"
              prop="coachManager"
              align="center"
              width="300"
            >
              <template slot-scope="detailsScope">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                  style="gap: 5px"
                >
                  <CoachManagerRel
                    v-for="coachManagerRel in detailsScope.row.coachManagers"
                    :key="coachManagerRel.id"
                    :relation="coachManagerRel"
                  />
                </div> </template
            ></el-table-column>
            <el-table-column
              v-if="status !== 'rejected'"
              label="Attribution"
              prop="attribution"
              align="center"
              width="300"
            >
              <template slot-scope="detailsScope">
                <button
                  v-if="
                    hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE') &&
                    !detailsScope.row.attribution
                  "
                  class="btn btn-success btn-sm"
                  @click="openAttributionModal(detailsScope.row)"
                >
                  <i class="fa fa-plus mr-05"></i> Créer une attribution
                </button>

                <button
                  v-else-if="
                    hasPermission($store.state.user, 'ATTRIBUTIONS_READ') &&
                    detailsScope.row.attribution
                  "
                  class="btn btn-warning btn-sm"
                  @click="goToAttribution(detailsScope.row.id)"
                >
                  <i class="fa fa-book mr-05"></i> Voir l'attribution
                </button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <!-- Details table to expand -->

      <el-table-column label="Faite le" prop="createdAt" width="120">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column label="Coach" prop="userId" width="180">
        <template slot-scope="scope">
          <DisplayCoachName
            :coach="scope.row.coach"
            cssClass="user-link"
          ></DisplayCoachName>
        </template>
      </el-table-column>
      <el-table-column label="Période" width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.start && scope.row.end">
            <strong>Période d'absence</strong><br />
            {{ formatDate(scope.row.start) }} &rarr;
            {{ formatDate(scope.row.end) }}
          </div>
          <div v-else-if="!scope.row.end">
            <strong>A partir du</strong><br />
            {{ formatDate(scope.row.start) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Cause"
        prop="reason"
        width="250"
      ></el-table-column>
      <el-table-column
        label="Note coach"
        prop="notes"
        width="200"
      ></el-table-column>
      <el-table-column
        label="Coach Manager"
        prop="coachManagers"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
            style="gap: 5px"
          >
            <CoachManagerRel
              v-for="coachManagerRel in scope.row.coachManagers"
              :key="coachManagerRel.id"
              :relation="coachManagerRel"
            />
          </div> </template
      ></el-table-column>
      <el-table-column label="Note CM" prop="adminNotes" width="250">
        <template slot-scope="scope">
          <NoteModal
            v-if="hasPermission($store.state.user, 'SUBSTITUTIONS_WRITE')"
            :notes="scope.row.adminNotes"
            :key="scope.row.id"
            permission="SUBSTITUTIONS_WRITE"
            @showComment="showAdminNotesModal(scope.row)"
          />
          <span v-else>{{ scope.row.adminNotes }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Clients/Commandes" align="center" width="170">
        <template slot-scope="scope">
          {{ scope.row.clients.length }} / {{ scope.row.orders.length }}
        </template>
      </el-table-column>
      <el-table-column label="Statut" align="center" width="120">
        <template slot-scope="scope">
          <SubsitutionStatusBadge :substitution="scope.row" />
        </template>
      </el-table-column>
      <el-table-column
        v-if="status === 'treated'"
        label="Validée le"
        prop="treatedAt"
        width="120"
      >
        <template v-if="scope.row.treatedAt" slot-scope="scope">
          {{ formatDate(scope.row.treatedAt) }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="status === 'rejected'"
        label="Refusée le"
        prop="treatedAt"
        width="120"
      >
        <template v-if="scope.row.rejectedAt" slot-scope="scope">
          {{ formatDate(scope.row.rejectedAt) }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="status === 'rejected'"
        label="Raison du refus"
        prop="rejectedReason"
        width="200"
      ></el-table-column>

      <el-table-column
        v-if="hasPermission($store.state.user, 'SUBSTITUTIONS_WRITE')"
        label="Actions"
        align="center"
        width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <template v-if="status === 'pending'">
            <button class="btn btn-sm btn-success" @click="treated(scope.row)">
              <i class="fa fa-check"></i>
            </button>
            <button
              class="btn btn-sm btn-danger ml-1"
              @click="reject(scope.row)"
            >
              <i class="fa fa-times"></i>
            </button>
          </template>

          <template v-else>
            <button class="btn btn-sm btn-info" @click="archive(scope.row)">
              <i class="fa fa-archive"></i>
            </button>

            <button
              class="btn btn-sm btn-outline-danger ml-1"
              @click="remove(scope.row)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <modal
      v-model="adminNotesModal.show"
      title="Note CM"
      cancelText="Annuler"
      okText="Enregistrer"
      @ok="editAdminNotes"
      @cancel="closeAdminNotesModal"
      effect="fade/zoom"
    >
      <template v-if="adminNotesModal.substitution">
        <textarea
          v-model="adminNotesModal.substitution.adminNotes"
          cols="30"
          rows="10"
          class="form-control form-normalization"
        >
        </textarea>
      </template>
    </modal>

    <modal
      v-model="rejectModal.show"
      title="Refuser la demande"
      okText="Confirmer"
      cancelText="Annuler"
      @ok="handleReject"
      @cancel="closeRejectModal"
      effect="fade/zoom"
    >
      <div class="form-group">
        <label>Raison du refus</label>
        <textarea
          v-model="rejectModal.rejectedReason"
          rows="5"
          class="form-control form-normalization"
        >
        </textarea>
      </div>
      <div class="alert alert-info">
        La raison du refus de la demande de remplacement sera visible par le
        coach dans son application.
      </div>
    </modal>

    <ModalNotebook
      :show="modalNotebook.show"
      :notebook="modalNotebook.notebook"
      :client="modalNotebook.client"
      :order="modalNotebook.order"
      @close="closeNotebook"
      @added="notebookNoteAdded"
      @updated="notebookNoteUpdated"
      @deleted="notebookNoteDeleted"
    />

    <ModalCreateAttribution
      :isShow="modalAttribution.show"
      :client="modalAttribution.client"
      :order="modalAttribution.order"
      @close="closeAttributionModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Modal from "vue-strap/src/Modal";
import Loader from "@/components/utils/Loader";
import DisplayCoachName from "@/components/coach/DisplayCoachName";
import NoteModal from "@/components/form/NoteModal";
import SubsitutionStatusBadge from "@/components/coach/SubsitutionStatusBadge";
import CommercialRel from "@/components/utils/CommercialRel";
import ModalNotebook from "@/components/modal/ModalNotebook";
import CoachManagerRel from "@/components/coach/CoachManagerRel";
import ModalCreateAttribution from "@/components/modal/ModalCreateAttribution";

export default {
  components: {
    Modal,
    DisplayCoachName,
    NoteModal,
    Loader,
    SubsitutionStatusBadge,
    CommercialRel,
    ModalNotebook,
    CoachManagerRel,
    ModalCreateAttribution,
  },

  props: {
    substitutions: {
      type: Array,
      default: null,
    },
    status: {
      type: String,
      default: "pending",
    },
  },

  data() {
    return {
      loading: false,
      showSubstitution: null,
      showClients: false,
      clients: null,
      adminNotesModal: {
        show: false,
        substitution: null,
      },
      rejectModal: {
        show: false,
        substitution: null,
        rejectedReason: "",
      },
      modalNotebook: {
        show: false,
        order: null,
        client: {},
        notebook: [],
      },
      modalAttribution: {
        show: false,
        client: null,
        order: null,
      },
      sendingNotification: [],
    };
  },

  computed: {
    ...mapGetters({
      coachSubstitutionReasons: "getCoachSubstitutionReasons",
    }),

    substitutionsData() {
      return this.substitutions.map((s) => {
        const reason = this.coachSubstitutionReasons.find(
          (r) => r.value === s.reason,
        );

        return {
          ...s,
          reason: reason?.label ?? s.reason,
          details: s.orders.map((o) => ({
            ...o,
            client: s.clients.find((c) => c.email === o.client),
            packName: o.discovery
              ? "Séance découverte"
              : `Pack ${o.session} séance${o.session > 1 ? "s" : ""}`,
          })),
        };
      });
    },
  },

  methods: {
    treated(substitution) {
      this.$confirm({
        message: "Valider la demande de remplacement ?",
        onConfirm: async () => {
          try {
            this.loading = true;

            await this.$api.patch(`/substitutions/${substitution.id}/validate`);

            this.$emit("treated", substitution.id);
          } catch (e) {
            this.$errorToast(
              "Impossible de valider la demande de remplacement",
            );
          } finally {
            this.loading = false;
          }
        },
      });
    },

    reject(substitution) {
      this.rejectModal.substitution = substitution;
      this.rejectModal.show = true;
    },

    archive(substitution) {
      let message = "Archiver la demande de remplacement ?";

      if (substitution.rejected) {
        message +=
          " Attention, la demande n'apparaîtra plus dans l'application du coach, assurez-vous qu'il a bien pris connaissance de la raison du refus avant d'archiver.";
      }

      message +=
        " Pour rappel, les coachs peuvent également archiver eux-mêmes leurs demandes depuis leur application.";

      this.$confirm({
        message,
        onConfirm: async () => {
          try {
            this.loading = true;

            await this.$api.put(`/substitutions/${substitution.id}`, {
              completed: true,
            });

            this.$emit("archived", substitution.id);
          } catch (e) {
            this.$errorToast(
              "Impossible d'archiver la demande de remplacement",
            );
          } finally {
            this.loading = false;
          }
        },
      });
    },

    remove(substitution) {
      this.$confirm({
        message:
          "Supprimer la demande de remplacement ? Cette action est irréversible.",
        onConfirm: async () => {
          try {
            this.loading = true;
            await this.$api.delete(`/substitutions/${substitution.id}`);

            this.$emit("archived", substitution.id);
          } catch (e) {
            this.$errorToast(
              "Impossible de supprimer la demande de remplacement",
            );
          } finally {
            this.loading = false;
          }
        },
      });
    },

    goToClient(id) {
      const route = this.$router.resolve({
        name: "client-details",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },

    showAdminNotesModal(substitution) {
      this.adminNotesModal.substitution = substitution;
      this.adminNotesModal.show = true;
    },

    async editAdminNotes() {
      try {
        this.loading = true;

        await this.$api.put(
          "/substitutions/" + this.adminNotesModal.substitution.id,
          {
            adminNotes: this.adminNotesModal.substitution.adminNotes,
          },
        );
      } catch (e) {
        this.$errorToast("Impossible de mettre à jour la note CM");
      } finally {
        this.loading = false;
        this.adminNotesModal.show = false;
        this.adminNotesModal.substitution = null;
      }
    },

    closeAdminNotesModal() {
      this.adminNotesModal.show = false;
      this.adminNotesModal.substitution = null;
    },

    async handleReject() {
      try {
        if (!this.rejectModal.substitution?.id) {
          return;
        }

        this.loading = true;

        await this.$api.patch(
          `/substitutions/${this.rejectModal.substitution.id}/reject`,
          {
            rejectedReason: this.rejectModal.rejectedReason.trim(),
          },
        );

        this.$emit(
          "rejected",
          this.rejectModal.substitution.id,
          this.rejectModal.rejectedReason.trim(),
        );
      } catch (e) {
        this.$errorToast("Impossible de refuser la demande de remplacement");
      } finally {
        this.loading = false;

        this.closeRejectModal();
      }
    },

    closeRejectModal() {
      this.rejectModal.show = false;
      this.rejectModal.substitution = null;
      this.rejectModal.rejectedReason = "";
    },

    goToOrder(id) {
      const route = this.$router.resolve({
        name: "order-details",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },

    showNotebook(order) {
      this.modalNotebook.order = order;
      this.modalNotebook.client = order.client || {};
      this.modalNotebook.notebook = order.notebook || [];
      this.modalNotebook.show = true;
    },

    closeNotebook() {
      this.modalNotebook.show = false;
      this.modalNotebook.order = null;
      this.modalNotebook.client = {};
      this.modalNotebook.notebook = [];
    },

    notebookNoteAdded(note) {
      this.$emit("notebookNoteAdded", {
        orderId: this.modalNotebook.order.id,
        note,
      });
    },

    notebookNoteUpdated(note) {
      this.$emit("notebookNoteUpdated", {
        orderId: this.modalNotebook.order.id,
        note,
      });
    },

    notebookNoteDeleted(noteId) {
      this.$emit("notebookNoteDeleted", {
        orderId: this.modalNotebook.order.id,
        noteId,
      });
    },

    goToAttribution(orderId) {
      const route = this.$router.resolve({
        name: "attributions-order",
        params: {
          id: orderId,
        },
      });

      window.open(route.href, "_blank");
    },

    openAttributionModal(order) {
      if (!order || !order.client) {
        return;
      }

      this.modalAttribution.order = order || null;
      this.modalAttribution.client = order.client || null;
      this.modalAttribution.show = true;
    },

    closeAttributionModal() {
      this.modalAttribution.show = false;
      this.modalAttribution.client = null;
      this.modalAttribution.order = null;
    },

    async notifyCommercial(email, substitutionId, orderId) {
      try {
        this.sendingNotification.push(orderId);

        await this.$api.post(
          `/substitutions/${substitutionId}/notify-commercial`,
          {
            commercialEmail: email,
            orderId,
          },
        );

        this.$successToast("Notification envoyée");
      } catch (e) {
        this.$errorToast("Impossible d'envoyer la notification au commercial");
      } finally {
        this.sendingNotification = this.sendingNotification.filter(
          (id) => id !== orderId,
        );
      }
    },
  },
};
</script>
